import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { Adresses } from '../components/list-addresses/interfaces/addresses-user.interface';

@Injectable({
  providedIn: 'root'
})
export class ModalViewLocationService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private isClosingSubject = new BehaviorSubject<boolean>(false);
  private editModeSubject = new BehaviorSubject<boolean>(false);
  private visibleMapSubject = new BehaviorSubject<boolean>(false);
  private editableAddressSubject = new BehaviorSubject<Adresses>(
    {ad_id: 0,
  ad_latitude: "",
  ad_longitude: "",
  ad_full_address: "",
  ad_user_id: "",
  created_at: "",
  updated_at: "",
  ad_reference: "",
  ad_name: ""});

  isOpen$ = this.isOpenSubject.asObservable();
  isClosing$ = this.isClosingSubject.asObservable();
  editMode$ = this.editModeSubject.asObservable();
  visibleMap$ = this.visibleMapSubject.asObservable();
  editableAddress$ = this.editableAddressSubject.asObservable();

  // Almacenar la ubicación seleccionada
  private selectedLocationSubject = new BehaviorSubject<{
    location: { lat: number, lng: number },
    address: string
  } | null>(null);
  selectedLocation$ = this.selectedLocationSubject.asObservable();

  constructor() { }

  toggleModal(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.isOpenSubject.value;
    // console.log('Toggling location modal:', newValue);

    // Si estamos cerrando el modal, primero activamos la animación de cierre
    if (this.isOpenSubject.value === true && newValue === false) {
      this.isClosingSubject.next(true);

      // Después de un tiempo para la animación, cerramos el modal
      setTimeout(() => {
        this.isOpenSubject.next(false);
        this.isClosingSubject.next(false);
      }, 300); // 300ms para coincidir con la duración de la animación CSS
    } else {
      // Si estamos abriendo el modal, lo hacemos inmediatamente
      this.isOpenSubject.next(newValue);
      this.isClosingSubject.next(false);
    }
  }

  setEditMode(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.editModeSubject.value;
    // console.log('edit mode:', newValue);

    this.editModeSubject.next(newValue);
  }

  showMap(value: boolean): void{
    this.visibleMapSubject.next(value);
  }

  sendAddress(address: Adresses){
    this.editableAddressSubject.next(address)
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }

  get isEditMode(): boolean{
    return this.editModeSubject.value;
  }

  get editableAddress(): Adresses{
    return this.editableAddressSubject.value;
  }
  // Método para establecer la ubicación seleccionada
  setSelectedLocation(location: { lat: number, lng: number }, address: string): void {
    this.selectedLocationSubject.next({ location, address });
  }

  // Método para obtener la ubicación seleccionada actual
  get selectedLocation(): { location: { lat: number, lng: number }, address: string } | null {
    return this.selectedLocationSubject.value;
  }
}